import { z } from "zod";
import { ExternalInvitationKind } from "../enum-external-invitation.js";

export const externalInvitationTokenPayloadSchema = z.object({
	kind: z.enum([ExternalInvitationKind.EVENT, ExternalInvitationKind.MEETING]),
	guestId: z.uuid(),
	resourceId: z.uuid(),
});

export type ExternalInvitationTokenPayload = z.infer<typeof externalInvitationTokenPayloadSchema>;

export type VerifyExternalInvitationTokenResult = { ok: true; payload: ExternalInvitationTokenPayload } | { ok: false; expired: boolean };
